// extracted by mini-css-extract-plugin
export default {"middleTitle":"MiddleTitle_middleTitle__LL7Ts"};